import React, { Component } from "react";
// core components
import MUIDataTable from "mui-datatables";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  fetchAisidle,
  fetchCatidleclose,
  fetchIdleCategory,
  fetchShiprtbt,
  fetchAisidleDaily
} from "../../api/portal";
import { pushLeftPanel } from "actions/dashboard";
import { NavLink, withRouter } from "react-router-dom";
import {
  pushZonaTarget,
  pushPoiTarget,
  pushShipTrack,
  pushShipTrack2
} from "actions/portal";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "components/CustomButtons/Button.jsx";
//import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import IdlecloseCat from "./idleclosecat";
import IconSettings from "@material-ui/icons/Settings";
import Select from "@material-ui/core/Select";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardBody from "components/Card/CardBody.jsx";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import _ from "lodash";
import buttonsStyle from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx";
import moment from "moment";
import { pushLoader } from "../../actions/main";
import BlockUi from "react-block-ui";
import ReactExport from "assets/libs/react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const fileName = `Approach Vessel ${moment().format("LLL")}`;

class Idleclose extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      datatable: [],
      openAdd: false,
      category: [],
      selectedCategory: "",
      catidle: [],
      idlechartcat: [],
      idlechartval: [],
      description: "",
      source: "AIS_MT",
      loader: null,
      loaderGraph: null
    };
  }

  getNameshiptype = shiptype => {
    let shipTypeString;
    switch (shiptype) {
      case 1:
        shipTypeString = "Unspecified Ships";
        break;
      case 2:
        shipTypeString = "Fishing";
        break;
      case 3:
        shipTypeString = "Tugs & Special Craft";
        break;
      case 4:
        shipTypeString = "High Speed Craft";
        break;
      case 5:
        shipTypeString = "Pleasure Craft";
        break;
      case 6:
        shipTypeString = "Passenger Vessel";
        break;
      case 7:
        shipTypeString = "Cargo Vessel";
        break;
      case 8:
        shipTypeString = "Tanker";
        break;

      case 99:
        shipTypeString = "Pertamina";
        break;
      default:
        shipTypeString = "Unspecified Ships";
        break;
    }

    return shipTypeString;
  };

  UNSAFE_componentWillMount() {
    this.props.pushLoader(true);
    this.setState({ loader: true, loaderGraph: true });
    fetchCatidleclose()
      .then(responsex => {
        if (responsex != null) {
          const dat = responsex.data.results;
          this.setState({
            catidle: dat,
            selectedCategory: dat[0].id,
            description:
              dat[0].description +
              " idle time " +
              dat[0].timeidle +
              " hours with distance around " +
              dat[0].distance +
              " meter"
          });
          fetchAisidleDaily()
            .then(response => {
              if (response != null) {
                let cat = [];
                let val = [];
                response.data.map(e => {
                  cat.push(this.getNameshiptype(parseInt(e[0])));
                  val.push(e[2]);
                });

                this.setState({
                  aisidlechartcat: cat,
                  aisidlechartdata: val
                });
              }
              this.setState({ loaderGraph: false });
            })
            .catch(error => {
              console.log(error);
              this.props.history.push("/pages/login#logout");
            });

          fetchAisidle(dat[0].id)
            .then(response => {
              let datanya = [];
              for (var key in response.data.results) {
                var aa = _.values(response.data.results[key]);
                //aa[2] = moment(aa[2], 'YYYY-MM-DD').format('DD-MM-YYYY');
                aa[12] = moment(aa[12], "YYYY-MM-DD HH:mm:ss").format(
                  "YYYY-MM-DD HH:mm:ss"
                );
                datanya.push({
                  name: aa[2],
                  shipid: aa[1],
                  near_shipid: aa[9],
                  shiptype: this.getNameshiptype(parseInt(aa[3])),
                  near_shiptype: this.getNameshiptype(aa[11]),
                  near_name: aa[10],
                  category: aa[7],
                  idletime: aa[15],
                  latitude: aa[5],
                  longitude: aa[6],
                  near_dateCreated: aa[12],
                  distance_meter: aa[18]
                });
              }
              this.setState({ datatable: datanya, loader: false });
            })
            .catch(error => {
              console.log(error);
              this.props.history.push("/pages/login#logout");
            });
        }
        this.props.pushLoader(false);
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.pushLoader(false);
        this.props.history.push("/pages/login#logout");
      });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      source: nextProps.sourceAis
    });
  }

  handleRowSelect = e => {
    //this.props.pushLeftPanel(!this.props.leftPanel);
    this.props.pushPoiTarget([e[7], e[8]]);
  };

  handleClose = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  renderOptcat = e => {
    return <MenuItem value={e.id}> {e.name} </MenuItem>;
  };

  handlecat = e => {
    const a = this.state.catidle;
    const b = _.find(a, { id: e.target.value });

    this.setState({
      selectedCategory: e.target.value,
      description: b.description + " idle time in hours " + b.timeidle
    });

    fetchIdleCategory(e.target.value)
      .then(response => {
        if (response != null) {
          let cat = [];
          let val = [];
          response.data.map(e => {
            cat.push(this.getNameshiptype(parseInt(e[0])));
            val.push(e[2]);
          });

          this.setState({
            aisidlechartcat: cat,
            aisidlechartdata: val
          });
        }
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });

    fetchAisidle(e.target.value)
      .then(response => {
        let datanya = [];
        for (var key in response.data.results) {
          var aa = _.values(response.data.results[key]);
          //aa[2] = moment(aa[2], 'YYYY-MM-DD').format('DD-MM-YYYY');
          datanya.push({
            name: aa[2],
            shipid: aa[1],
            near_shipid: aa[9],
            shiptype: this.getNameshiptype(parseInt(aa[3])),
            near_shiptype: this.getNameshiptype(aa[11]),
            near_name: aa[10],
            category: aa[7],
            idletime: aa[14],
            latitude: aa[5],
            longitude: aa[6],
            near_dateCreated: aa[12],
            distance_meter: aa[17]
          });
        }
        this.setState({ datatable: datanya });
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handleShow = (shipid, near_shipid, datenya) => {
    let lonlat = [];
    let lonlat1 = [];

    let start = new Date(datenya);
    let startDate = new Date(start.getTime() - 7 * 24 * 60 * 60 * 1000);
    startDate.setHours(0, 0, 0, 0);
    let end = new Date(datenya);
    end.setHours(24, 0, 0, 0);

    let timeStart = moment(startDate).format("YYYY-MM-DD HH:mm:ss");
    let timeEnd = moment(end).format("YYYY-MM-DD HH:mm:ss");

    fetchShiprtbt(shipid, timeStart, timeEnd, this.state.source)
      .then(response => {
        response.data.results.map(ee => {
          lonlat.push([
            parseFloat(ee.lon).toFixed(4),
            parseFloat(ee.lat).toFixed(4),
            ee.date_created,
            ee.speed
          ]);
        });
        this.props.pushShipTrack(lonlat.toString());
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });

    fetchShiprtbt(near_shipid, timeStart, timeEnd, "AIS_MT")
      .then(response => {
        response.data.results.map(ee => {
          lonlat1.push([
            parseFloat(ee.lon).toFixed(4),
            parseFloat(ee.lat).toFixed(4),
            ee.date_created,
            ee.speed
          ]);
        });
        this.props.pushShipTrack2(lonlat1.toString());
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  render() {
    const columns = [
      {
        name: "shipid",
        label: "Shipid",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "near_shipid",
        label: "Near Shipid",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "name",
        label: "Vessel Name",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "shiptype",
        label: "Ship Type",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "near_shiptype",
        label: "Near Ship Type",
        options: {
          filter: false,
          display: true,
          customBodyRender: val => <font color="red">{val}</font>
        }
      },
      {
        name: "near_name",
        label: "Near Vessel",
        options: {
          filter: false,
          display: true,
          customBodyRender: val => <font color="red">{val}</font>
        }
      },
      {
        name: "category",
        label: "Category",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "idletime",
        label: "Idle Time in Hour",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "distance_meter",
        label: "Distance Meter",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "latitude",
        label: "Latitude",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "longitude",
        label: "Longitude",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "near_dateCreated",
        label: "Date Time",
        options: {
          filter: true,
          display: true
        }
      },
      {
        name: "Action",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                <NavLink
                  to={"/portal"}
                  onClick={() => {
                    this.props.pushPoiTarget([
                      tableMeta.rowData[9],
                      tableMeta.rowData[10]
                    ]);
                    this.handleShow(
                      tableMeta.rowData[0],
                      tableMeta.rowData[1],
                      tableMeta.rowData[11]
                    );
                  }}
                >
                  <Button size="sm" color="behance" round>
                    View on Map
                  </Button>
                </NavLink>
              </div>
            );
          }
        }
      }
    ];

    const optionsChart3 = {
      chart: {
        type: "column"
      },
      credits: {
        enabled: false
      },
      title: {
        text: "Ship type"
      },
      xAxis: {
        categories: this.state.aisidlechartcat
      },
      yAxis: {
        title: {
          text: "Volume Vessel"
        }
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true
          },
          enableMouseTracking: false
        }
      },
      series: [
        {
          name: "Ship Type",
          data: this.state.aisidlechartdata
        }
      ]
    };

    const options = {
      filter: false,
      search: true,
      selectableRows: false,
      print: true,
      download: true,
      responsive: "scroll",
      viewColumns: true,
      textLabels: {
        body: {
          noMatch: this.state.loader
            ? "Searching..."
            : "Sorry, no matching records found"
        }
      }
    };

    return (
      <div>
        <Grid item xs={12}>
          <Button
            color="success"
            round
            onClick={() => this.handleClose("openAdd", true)}
          >
            <IconSettings /> Manage Category
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <FormControl variant="outlined">
                <Select
                  value={this.state.selectedCategory}
                  onChange={this.handlecat}
                >
                  {this.state.catidle.map(this.renderOptcat)}
                </Select>
              </FormControl>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <span>
                <b>description: </b>
                {this.state.description}
              </span>
            </CardContent>
          </Card>
        </Grid>
        <BlockUi tag="div" blocking={this.state.loaderGraph} message="Loading">
          <HighchartsReact highcharts={Highcharts} options={optionsChart3} />
        </BlockUi>
        <ExcelFile
          element={
            <Button
              color="primary"
              variant="contained"
              disabled={this.state.loader}
            >
              Download as .xslx
            </Button>
          }
          filename={`${fileName}`}
          fileExtension="xslx"
        >
          <ExcelSheet data={this.state.datatable} name="Sheet 1">
            <ExcelColumn label="Vessel Name" value="name" />
            <ExcelColumn label="Ship Type" value="shiptype" />
            <ExcelColumn label="Near Ship Type" value="near_shiptype" />
            <ExcelColumn label="Near Vessel" value="near_name" />
            <ExcelColumn label="Category" value="category" />
            <ExcelColumn label="Idle Time in Hour" value="idletime" />
            <ExcelColumn label="Distance Meter" value="distance_meter" />
            <ExcelColumn label="Date" value="near_dateCreated" />
          </ExcelSheet>
        </ExcelFile>
        <MUIDataTable
          data={this.state.datatable}
          columns={columns}
          options={options}
        />
        <Dialog
          maxWidth={"md"}
          open={this.state.openAdd}
          onClose={() => this.handleClose("openAdd", false)}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Manage Category</DialogTitle>
          <DialogContent>
            <IdlecloseCat />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.handleClose("openAdd", false)}
              color="danger"
              round
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

Idleclose.propTypes = {
  pushLeftPanel: PropTypes.array,
  pushZonaTarget: PropTypes.string,
  pushPoiTarget: PropTypes.array,
  pushShipTrack: PropTypes.array,
  pushShipTrack2: PropTypes.array
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    rightPanel: state.rightPanel,
    leftPanel: state.leftPanel,
    sourceAis: state.sourceAis
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    pushLeftPanel,
    pushZonaTarget,
    pushPoiTarget,
    pushShipTrack,
    pushShipTrack2,
    pushLoader
  }
)(Idleclose));
